const SHAPES_TYPES = [
    'cylinder',
    'rectangular',
];

const CYLINDER_UNIT = [
    'in',
    'cm',
    'mm',
];

const RECTANGULAR_UNIT = [
    'in',
    'cm',
    'mm',
];

const BASE_SIZES = [
    'diameter',
    'radius',
];


module.exports = {
    SHAPES_TYPES,
    CYLINDER_UNIT,
    RECTANGULAR_UNIT,
    BASE_SIZES,
};
